const KEY = 'custom_tokens';

export function getCustomTokens(chain) {
  const all = JSON.parse(localStorage.getItem(KEY) || '{}');
  return all[chain] || [];
}

export function addCustomToken(chain, token) {
  const all = JSON.parse(localStorage.getItem(KEY) || '{}');
  if (!all[chain]) all[chain] = [];
  const exists = all[chain].find(t => t.address.toLowerCase() === token.address.toLowerCase());
  if (!exists) {
    all[chain].push({ ...token, addedAt: Date.now() });
    localStorage.setItem(KEY, JSON.stringify(all));
  }
}

export function removeCustomToken(chain, address) {
  const all = JSON.parse(localStorage.getItem(KEY) || '{}');
  if (all[chain]) {
    all[chain] = all[chain].filter(t => t.address.toLowerCase() !== address.toLowerCase());
    localStorage.setItem(KEY, JSON.stringify(all));
  }
}

export function getAllCustomTokens() {
  return JSON.parse(localStorage.getItem(KEY) || '{}');
}
